import { useQuery } from '@tanstack/react-query';
import { awaitJSON, SheetsLambdaFetch } from '@src/utils/fetch-utils';
import { KpiRow } from './kpi-setup-constants';

export const useCompanyIds = (): ReturnType<typeof useQuery<string[]>> =>
  useQuery({
    queryKey: ['kpiSetupCompanyIds'],
    queryFn: async (): Promise<string[]> => {
      const { ids } = await awaitJSON<{ ids: string[] }>(
        await SheetsLambdaFetch('/get_company_ids')
      );
      return ids;
    }
  });

export const useCompanyKpis = (company: string | null): ReturnType<typeof useQuery<KpiRow[]>> =>
  useQuery({
    queryKey: ['kpiSetupCompanyKpis', company],
    queryFn: async (): Promise<KpiRow[]> => {
      const { kpis } = await awaitJSON<{ kpis: KpiRow[] }>(
        await SheetsLambdaFetch('/get_company_kpis', { params: { company } })
      );
      return kpis;
    },
    enabled: false
  });

export const saveCompanyKpis = async (company: string, kpis: KpiRow[]): Promise<void> => {
  await SheetsLambdaFetch('/set_company_kpis_ordering', {
    method: 'POST',
    body: { company, kpis }
  });
};
